import {Config} from "../config/config";

export enum clientRoles {
  OWNER = 1,
  COMPANY_ADMIN = 2,
  COMPANY_DEV = 3,
  SITE_DEV = 4,
  SUITE_DEV = Config.suiteDev,
}

export enum clientRolesSlug {
  'Owner' = 1,
  'Admin',
  'Contributor',
  'Member'
}

export enum UserRolesActions {
  ADD_USER = 'add_user',
  INVITE_USER = 'invite_user',
  DELETE_USER = 'delete_user',
  EDIT_USER_ROLES = 'edit_user_roles',
  ADD_HOSTED_WEBSITE = 'add_hosted_website',
  CONNECT_WEBSITE = 'connect_website',
  MIGRATE_WEBSITE = 'migrate_website',
  FULL_ACCESS_HOSTED_WEBSITES = 'full_access_hosted_websites',
  FULL_ACCESS_CONNECTED_WEBSITES = 'full_access_connected_websites',
  ACCESS_STAGING_ENV = 'access_staging_env',
  PUSH_TO_LIVE = 'push_to_live',
  SYNC_WITH_LIVE = 'sync_with_live',
  EDIT_BILLING_INFO = 'edit_billing_info',
  VIEW_INVOICES = 'view_invoices',
  CANCEL_SUBSCR = 'cancel_subscr',
  ACTIVATE_SUBSCR = 'activate_subscr',
  RENEW_SUBSCR = 'renew_subscr',
  UPGRADE_PLAN = 'upgrade_plan',
  WHITE_LABEL = 'white_label',
}
